import { all, put, takeLatest } from "redux-saga/effects";

import {
  FETCH_ATTENDANCE_TIMELINE,
  FETCH_ATTENDANCE_TIMELINE_FAILURE,
  FETCH_ATTENDANCE_TIMELINE_SUCCESS,
  GET_CLOCK_IN_OUT_LIST,
  GET_CLOCK_IN_OUT_LIST_FAILURE,
  GET_CLOCK_IN_OUT_LIST_SUCCESS,
} from "../../modules/constants";
import { defaultApi } from "../../utils/axiosApi";

export function* getClockInOutList({ payload }) {
  const {
    start_timestamp,
    end_timestamp,
    name,
    page,
    office,
    employee_id,
  } = payload;
  try {
    const url = `albait/attendaces/?from=${start_timestamp}&to=${end_timestamp}${
      name ? `&name=${name}` : ``
    }${page ? `&page=${page}` : ``}${office ? `&office=${office}` : ``}${
      employee_id ? `&employee_id=${employee_id}` : ``
    }&platform=web`;
    const method = "GET";
    const response = yield defaultApi(url, method);
    yield put({
      type: GET_CLOCK_IN_OUT_LIST_SUCCESS,
      payload: { data: response },
    });
  } catch (err) {
    yield put({
      type: GET_CLOCK_IN_OUT_LIST_FAILURE,
      payload: err,
    });
  }
}

export function* fetchAttendanceTimeline({ payload }) {
  const { attendance_id } = payload;
  try {
    const url = `albait/geofence-exit-out/?attendance_id=${attendance_id}`;
    const method = "GET";
    const response = yield defaultApi(url, method);
    yield put({
      type: FETCH_ATTENDANCE_TIMELINE_SUCCESS,
      payload: { data: response },
    });
  } catch (err) {
    yield put({
      type: FETCH_ATTENDANCE_TIMELINE_FAILURE,
      payload: err,
    });
  }
}


export default function* clockInOutSagas() {
  yield all([takeLatest(GET_CLOCK_IN_OUT_LIST, getClockInOutList)]);
  yield all([takeLatest(FETCH_ATTENDANCE_TIMELINE, fetchAttendanceTimeline)]);
}
